import React from 'react'
import './bannerJackpot.scss'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { graphql, useStaticQuery } from 'gatsby'
import ArrowScrollDown from "../arrowScrollDown/arrowScrollDown";

const BannerJackpot = () => {
  const {
    bannerJackpotLarge: { childImageSharp: bannerJackpotLarge },
    bannerJackpotSmall: { childImageSharp: bannerJackpotSmall },
  } = useStaticQuery(graphql`
    {
      bannerJackpotLarge: file(name: { eq: "banner-award" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      bannerJackpotSmall: file(name: { eq: "banner-award-mobile" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)

  return (
    <div className="f-banner-jackpot">
      <div className="f-banner-jackpot__container">
        <GatsbyImage
          objectFit="contain"
          image={withArtDirection(getImage(bannerJackpotLarge), [
            {
              media: '(max-width: 1024px)',
              image: getImage(bannerJackpotSmall),
            },
          ])}
          alt="Premio Mayor"
          className="f-banner-jackpot__image"
        />
      </div>
      <ArrowScrollDown color='pink' scroll={401}/>
    </div>
  )
}

export default BannerJackpot
